import React, { useState, useEffect, useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import CustomModal from '../../Modal';
import Constructor from '../Constructor/Constructor';
import CustomTooltip from "../../Tooltip";
import ClipboardCopy from "../../../helpers/ClipboardCopy";
import CustomNotify from "../../Notify";
import { I18nContext } from 'utils/I18n/context';

const promoError = 'promoError';

const creativeType = 'promocode';

const PromoCodeListConstructorComponent = (props) => {
    const { t } = useContext(I18nContext);
    const constructorMethods = Constructor(props);
    
    const [state, setState] = useState({
        creativeType: props.creativeType || creativeType,
        creativeId: props.creativeId || props.linkId,
        link: props.link,
        modalIsVisible: props.visible,
        goalEntries: props.goalEntries,
        publisherId: props.publisherId,
        metaParams: {},
        metaParamsmetaParams: {},
        selfieLink: '',
        currentLinkId: '',
        resultLink: '',
        type: props.type,
        codeParams: {},
        promoTitle: props.promocode && props.promocode.title ? props.promocode.title : "",
        description: props.promocode && props.promocode.description ? props.promocode.description : "",
        errors: '',
        modalOptions: {
            promocode: {
                title: t?.constructors?.promocodes || 'Promocodes',
                pattern: '{{ promocode }}'
            },
            container: {
                title: t?.constructors?.promocodes || 'Promocodes',
                pattern: '<iframe src="{{ promocode }}" width="{{ width }}" height="{{ height }}" align="middle">{{ text }}</iframe>'
            }
        }
    });

    useEffect(() => {
        initLink();
    }, []);

    useEffect(() => {
        const isChangeLinkId = state.linkId !== props.linkId;
        let promoTitle = props.promocode ? props.promocode.title : "";
        let description = props.promocode ? props.promocode.description : "";

        setState(prev => ({
            ...prev,
            creativeType: props.creativeType || creativeType,
            creativeId: props.creativeId || props.linkId,
            goalEntries: props.goalEntries,
            publisherId: props.publisherId,
            link: props.link,
            promocode: props.promocode,
            type: props.type,
            selfieLink: '',
            codeParams: props.codeParams || {},
            access: !!constructorMethods.getFirstGoal() && props.access,
            modalIsVisible: props.visible,
            promoTitle: props.promoTitle || promoTitle,
            description: props.description || description,
            errors: props.errors,
            goalEntryId: props.goalEntryId || constructorMethods.getFirstGoal()
        }));

        if (isChangeLinkId) {
            initLink();
        }
    }, [props]);

    const initLink = useCallback(() => {
        if (!state.linkId) {
            return;
        }
        props.getDataLink(state.linkId, successLink);
    }, [state.linkId, props]);

    const successLink = useCallback((data) => {
        setState(prev => ({
            ...prev,
            link: data
        }));
    }, []);

    const close = useCallback(() => {
        props.onClose();
    }, [props]);

    const onClickEditPromoCode = useCallback((linkId, promocode) => {
        // this.context.showConstructorPromoCode({'linkId': linkId, 'promocode': promocode});
    }, []);

    const onClickDeletePromoCode = useCallback((promoCodeId) => {
        let link = { ...state.link };
        link.promo_codes.map((promoCode, j) => {
            if(promoCode.id === promoCodeId) {
                delete link.promo_codes[j];
            }
        })

        setState(prev => ({
            ...prev,
            link: link
        }));

        props.deletePromoCode(promoCodeId, t, onSuccess, onError);
    }, [state.link, props, t]);

    if(undefined === state.modalOptions[state.type] || undefined === state.link) {
        return '';
    }

    if ("object" === typeof state.link && 0 === Object.keys(state.link).length && state.modalIsVisible) {
        return '';
    }

    let options = state.modalOptions[state.type];

    let editPromoCode = false;

    return (
        <div className="promocode-construrtor">
            <CustomModal
                visible={state.modalIsVisible}
                onClose={props.onClose}
                onConfirm={editPromoCode ? edit : confirm}
                confirmName={t?.constructors?.save || 'Save'}
                title={t?.constructors?.promocodes || 'Promocodes'}
                bsSize={'sm'}
                className={'modal__promo_list'}
                areNoControls={true}
            >
                <div className="offer-item__promo-links-wrap">
                    <div className="link-title"><span>{state.link.title}</span></div>
                    <div className="link-url"><span>{state.link.url}</span></div>
                    <div className="promo-code-tree">
                        {state.link.promo_codes.map((promoCode, key) => (
                            <div className="promo-code-tree__item" key={key}>
                                <div className="item-desc" data-index={promoCode.id}>
                                    <span>{promoCode.title}</span><br/>
                                    <span className="item-desc__description">{promoCode.description}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </CustomModal>
        </div>
    );
};

PromoCodeListConstructorComponent.propTypes = {
    offer: PropTypes.object.isRequired,
    goalEntryId: PropTypes.string,
    linkId: PropTypes.string,
    visible: PropTypes.bool,
    access: PropTypes.bool,
    type: PropTypes.string,
    getDataLink: PropTypes.func,
    onClose: PropTypes.func,
    deletePromoCode: PropTypes.func
};

PromoCodeListConstructorComponent.defaultProps = {
    type: creativeType,
    getDataLink: () => {},
    onClose: () => {},
    deletePromoCode: () => {}
};

export default PromoCodeListConstructorComponent;